import {STANDINGS_WIDGET} from "../standings-widget.consts";
import {StandingsWidgetState} from "../models/standings-widget.state";
import {StandingsWidgetController} from "../standings-widget.controller";
import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {ACTION_TYPES, COMPONENT_STATES} from "../../../core/consts";

export class StandingsWidgetStageChangeHandler extends ActionHandler {
  controller: StandingsWidgetController;
  state: StandingsWidgetState;
  type = STANDINGS_WIDGET.ACTION_TYPES.onStageChange;

  static injectables = [...ActionHandler.injectables];

  async action(params) {
    this.store.setComponentState(COMPONENT_STATES.loading);
    this.state.currentStageNum = params.stage?.num;
    await this.controller.action(STANDINGS_WIDGET.ACTION_TYPES.changeType, {index: null, disableFetch: true});

    await this.controller.action(ACTION_TYPES.fetch, {isPartialFetch: true});
    this.store.setComponentState(COMPONENT_STATES.loaded);
    return params;
  }
}
